/**
 * The web build's sign-in configs from its VITE_* values: Google Identity Services takes the web
 * OAuth client id, Sign in with Apple JS takes the Services ID and a return URL registered on it.
 * An IdP left unset stays out of auth=auto, so the account view offers only what is configured.
 * The native build uses the system sheets instead (native/config.ts).
 *
 *   VITE_GOOGLE_WEB_CLIENT_ID   …apps.googleusercontent.com (the id token audience: IDP_GOOGLE_AUDIENCE)
 *   VITE_APPLE_SERVICES_ID      e.g. com.innoedgetech.marketpop.web (IDP_APPLE_AUDIENCE)
 *   VITE_APPLE_REDIRECT_URI     a Return URL of that Services ID; default the page origin + '/'
 */
import type { ProvidersConfig } from '@mp/adapters/providers';

type Env = Readonly<Record<string, unknown>>;

const value = (env: Env, key: string): string | undefined => {
  const v = env[key];
  return typeof v === 'string' && v.trim() !== '' ? v.trim() : undefined;
};

export function webSignIn(env: Env, origin: string): NonNullable<ProvidersConfig['auth']> {
  const google = value(env, 'VITE_GOOGLE_WEB_CLIENT_ID');
  const apple = value(env, 'VITE_APPLE_SERVICES_ID');
  return {
    ...(google ? { google: { clientId: google } } : {}),
    ...(apple ? { apple: { clientId: apple, redirectUri: value(env, 'VITE_APPLE_REDIRECT_URI') ?? `${origin}/` } } : {}),
  };
}
